///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2020 - 2021
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import React, { Fragment } from "react";

import Spinner from "../icons/Spinner";
import ErrorIcon from "../icons/ErrorIcon";
import messages from "../../helpers/messages";

export const PanelStateIndicator = ({
  loading,
  error,
  errorMessage = messages.pleaseRefreshTheWidget.defaultMessage,
  handleRefresh,
  iconSize = "40px",
  buttonStyle
}) => (
  <Fragment>
    {loading && (
      <Spinner
        className="box-content spinner"
        height="40px"
        width="40px"
        fill="#C9CACC"
      />
    )}
    {error && (
      <div className="box-content text-center">
        <ErrorIcon height={iconSize} width={iconSize} fill="#C9CACC" />
        <p
          data-testid="error-message"
          className="block box-content pr-4 mt-8 text-light-grey font-size-14 pt-6"
        >
          {errorMessage}
        </p>
        {handleRefresh && (
          <button
            style={buttonStyle}
            data-testid="refresh-button"
            onClick={handleRefresh}
            className="refresh-button secondary-button mt-12 font-size-14 univers-65-bold"
          >
            {messages.refresh.defaultMessage}
          </button>
        )}
      </div>
    )}
  </Fragment>
);

export default PanelStateIndicator;
